import { Button, Modal, Progress, Spin, Upload } from "antd";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import * as Yup from "yup";
import umbuslogo from "../../../asserts/umbuslogo.png";
import {
  SubmitAddressData,
  SubmitCompanyData,
  SubmitDocumentsData,
} from "../../../Api/UserManagement/SuperAdmin";
import {
  GetEmpDocumentById,
  SubmitEmpDocumentsData,
} from "../../../Api/UserManagement/Employee";
import { useDispatch } from "react-redux";
import { actions } from "react-table";
import usePreventDragAndDrop from "../../Hooks/usePreventDragAndDrop";

const FILE_SIZE = 1024 * 1024 * 5; // 5MB
const SUPPORTED_FORMATS = [
  "application/pdf",
  "image/jpg",
  "image/jpeg",
  "image/png",
];
const noSpecialCharsRegex = /^[A-Z0-9]+$/;

const validationSchema = Yup.object().shape({
  // aadhar_number: Yup.string()
  //   .required("Aadhaar number is required")
  //   .test("aadhar-priority-check", function (value) {
  //     const { path, createError } = this;
  //     const val = value || "";
  
  //     if (/[^a-zA-Z0-9]/.test(val)) {
  //       return createError({
  //         path,
  //         message: "Aadhaar not contain special characters",
  //       });
  //     }
  
  //     if (/[a-zA-Z]/.test(val)) {
  //       return createError({
  //         path,
  //         message: "Aadhaar must not contain alphabets",
  //       });
  //     }
  
  //     if (val.length !== 12) {
  //       return createError({
  //         path,
  //         message: "Aadhaar must be exactly 12 digits",
  //       });
  //     }
  
  //     return true;
  //   }),
  aadhar_number: Yup.string()
  .required("Aadhaar number is required")
  .test("aadhar-priority-check", function (value) {
    const { path, createError } = this;
    const val = value || "";

    // Check for special characters first
    if (/[^0-9a-zA-Z]/.test(val)) {
      return createError({
        path,
        message: "Aadhaar not contain special characters",
      });
    }

    // Check for alphabets
    if (/[a-zA-Z]/.test(val)) {
      return createError({
        path,
        message: "Aadhaar must not contain alphabets",
      });
    }

    // Check for exact length
    if (val.length !== 12) {
      return createError({
        path,
        message: "Aadhaar must be exactly 12 digits",
      });
    }

    return true;
  }),

  
      
    // pan_number: Yup.string()
    //   .required("PAN number is required")
    //   .length(10, "PAN number must be exactly 10 characters")
    //   .test("pan-priority-check", function(value) {
    //     const { path, createError } = this;
  
    //     if (!/^[A-Z0-9]+$/.test(value || "")) {
    //       return createError({ path, message: "PAN must not contain special characters" });
    //     }
  
    //     if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value || "")) {
    //       return createError({ path, message: "PAN must be in the format ABCDE1234F" });
    //     }
  
    //     return true;
    //   }),

    pan_number: Yup.string()
  .required("PAN number is required")
  // .length(10, "PAN number must be exactly 10 characters")
  .test("pan-priority-check", function (value) {
    const { path, createError } = this;
    const val = value || "";

    // 1. Check for special characters first
    if (/[^A-Z0-9]/.test(val)) {
      return createError({
        path,
        message: "PAN must not contain special characters",
      });
    }

    // 2. Check for valid PAN format: 5 letters, 4 digits, 1 letter
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(val)) {
      return createError({
        path,
        message: "PAN must be in the format ABCDE1234F",
      });
    }

    if (val.length !== 10) {
      return createError({
        path,
        message: "PAN must be exactly 10 digits",
      });
    }

    return true;
  }),

  aadhar_doc: Yup.mixed()
    .required("Aadhaar front page is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  aadhar_bk_doc: Yup.mixed()
    .required("Aadhaar back page is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  pan_doc: Yup.mixed()
    .required("PAN front page is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  pan_bk_doc: Yup.mixed()
    .required("PAN back page is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  qualification: Yup.mixed()
    .required("Qualification doc is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  offerletter: Yup.mixed()
    .required("Offer letter doc is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  // edu_cer_doc: Yup.mixed()
  //   .required("MSME Image is required")
  //   .test("fileSize", "File too large", (value) =>
  //     typeof value === "string" ? true : value && value.size <= FILE_SIZE
  //   )
  //   .test("fileFormat", "Unsupported Format", (value) =>
  //     typeof value === "string"
  //       ? true
  //       : value && SUPPORTED_FORMATS.includes(value.type)
  //   ),
});

export default function AddDocuments({
  setCurrentpage,
  currentpage,
  SPA_ID,
  superadmindata,
  EmployeeID,
  setEmployeeID,
  operatorID,
  setDocumentBack,
  setModalIsOpen,
  updatedata,
}) {
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;
  const [spinning, setSpinning] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [inputPreview, setInputPreview] = useState({
    aadharfr: null,
    aadharbk: null,
    panfr: null,
    panbk: null,
    qualification: null,
    offerletter: null,
  });
    const handleKeyDown = (e) => {
    // Allow control keys like Backspace, Delete, ArrowLeft, ArrowRight, Tab
    const isControlKey = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ].includes(e.key);

    if (isControlKey) {
      return; // If it's a control key, do nothing and allow it to execute
    }

    // Allow only alphabets (A-Z, a-z), numbers (0-9), and space
    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault(); // Block all other characters
    }
  };

const handleFileChange = (event, key) => {
  const file = event?.currentTarget?.files?.[0];

  if (!file) return;

  // Clear preview when PDF
  if (file.type === "application/pdf") {
    setInputPreview((prev) => ({
      ...prev,
      [key]: null,  // wipe previous image preview
    }));
    return; // stop here
  }

  // Otherwise, image → generate preview
  if (file instanceof File) {
    setInputPreview((prev) => ({
      ...prev,
      [key]: URL.createObjectURL(file),
    }));
  }
};

  // const handlePreview = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     setPreviewImage(reader.result);
  //     setPreviewTitle(file.name);
  //   };
  //   reader?.readAsDataURL(file);
  // };

  // const handleSubmit = async (values) => {
  //   if (operatorID) {
  //     setCurrentpage(5);
  //   } else {
  //     try {
  //       const data = await SubmitDocumentsData(values);
  //       toast.success(data?.message);
  //       setCurrentpage(5);
  //     } catch (error) {
  //       console.error("Error uploading data", error);
  //     }
  //   }
  // };
  const [enable, setEnable] = useState(false);
  const dispatch = useDispatch();

  // const handleSubmit = async (values, actions) => {

  //   console.log(values,"docvalues");

  //   try {
  //     if (operatorID) {

  //       setCurrentpage(5); // Assuming setCurrentPage is a function in your component
  //     } else {
  //       const data = await SubmitEmpDocumentsData(values, EmployeeID, dispatch);
  //       console.log(data, "dataascbkjasbckja"); // Replace with actual API call function
  //       toast.success(data);
  //       setCurrentpage(5); // Assuming setCurrentPage is a function in your component
  //       setModalIsOpen(false);
  //     }
  //   } catch (error) {
  //     console.error("Error uploading data", error);
  //     toast.error("Failed to submit document. Please try again."); // Notify user of error
  //   } finally {
  //     actions.setSubmitting(false);
  //   }
  // };

  const handleSubmit = async (values, actions) => {
    if (updatedata && empDocumentdata?.aadhar_card_front_doc && enable == false) {
      setCurrentpage(5);
      setModalIsOpen(false);
      toast.success("Employee updated sucessfully")
    } else {
      try {
        const data = await SubmitEmpDocumentsData(values, EmployeeID, dispatch);
        console.log(data, "dataascbkjasbckja"); // Replace with actual API call function
        toast.success("Employee Professional Documents are Uploaded Successfully.");
        setCurrentpage(5); // Assuming setCurrentPage is a function in your component
        setModalIsOpen(false);
      } catch (error) {
        console.error("Error uploading data", error);
        toast.error("Failed to submit document. Please try again.");
      } finally {
        actions.setSubmitting(false);
      }
    }
    console.log(values, "valuesvalues");
    sessionStorage.removeItem("Employee_Id");
  };

  console.log(currentpage, "currentpagecurrentpage");

  const handleCancel = () => setPreviewOpen(false);

  const [empDocumentdata, setEmpDocumentData] = useState("");

  const fetchGetUser = async () => {
    try {
      const data = await GetEmpDocumentById(
        EmployeeID,
        setEmployeeID,
        setEmpDocumentData,
        setSpinning
      );
      setEmpDocumentData(data);
    } catch (error) {
      console.error("Error fetching additional user data", error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const openModal = (event) => {
    // Get the image source (src) using `getElementById`
    const imageSrc = event.target.getAttribute("src");

    // Set the modal image source
    setModalImage(imageSrc);

    // Open the modal
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (EmployeeID != null) {
      fetchGetUser();
      setSpinning(true)
    }
  }, [EmployeeID, setEmployeeID, setEmpDocumentData]);

  console.log(empDocumentdata, "empDocumentdataempDocumentdata");

  useEffect(() => {
    setInputPreview({
      aadharfr: empDocumentdata?.aadhar_card_front_doc,
      aadharbk: empDocumentdata?.aadhar_card_back_doc,
      panfr: empDocumentdata?.pan_card_front_doc,
      panbk: empDocumentdata?.pan_card_back_doc,
      qualification: empDocumentdata?.qualification_doc,
      offerletter: empDocumentdata?.offer_letter_doc,
    });
  }, [empDocumentdata]);
// to avoid image drag in input field
const inputRef1 = useRef(null);
const inputRef2 = useRef(null);


usePreventDragAndDrop(inputRef1);
usePreventDragAndDrop(inputRef2);

  return (
    <div className="relative mt-[1.5vw]">
      <div className="w-[5vw] h-[5vw] bg-white shadow-lg rounded-full absolute left-[16.6vw] top-[-2.5vw] flex justify-center items-center z-[1]">
        <img className="" src={umbuslogo} alt="buslogo" />
      </div>
      <div className="border-l-[0.1vw] relative  pl-[2vw] pr-[1.5vw] border-t-[0.1vw] border-b-[0.3vw] border-r-[0.1vw] rounded-[1vw] border-[#1f4b7f]">
        <div className="h-[4vw] w-full flex items-center justify-between">
          <label className="text-[1.5vw] font-semibold text-[#1f4b7f]">
            Documents
          </label>
          {/* <button className="rounded-full font-semibold w-[6vw] h-[2vw] flex items-center justify-center border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] border-r-[0.1vw] border-[#34AE2A] text-[1.1vw] text-[#34AE2A]">
            Save
          </button> */}
          {updatedata && empDocumentdata?.aadhar_card_front_doc ? (
            <button
              className={`${enable
                ? "bg-[#1f4b7f] text-white"
                : "text-[#1f4b7f] bg-white border-[#1f4b7f]"
                } rounded-full font-semibold w-[10vw] h-[2vw] flex items-center justify-center border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] border-r-[0.1vw] text-[1.1vw] `}
              onClick={() => {
                setEnable(!enable);
              }}
            >
              Enable to Edit
            </button>
          ) : (
            ""
          )}
        </div>
        <div className="pb-[1vw]">
          <div className="border-b-[0.1vw] w-full border-[#1f4b7f]"></div>
        </div>
        <Formik
          initialValues={{
            aadhar_number: empDocumentdata?.aadhar_card_number || "",
            pan_number: empDocumentdata?.pan_card_number || "",
            aadhar_doc: empDocumentdata?.aadhar_card_front_doc || null,
            aadhar_bk_doc: empDocumentdata?.aadhar_card_back_doc || null,
            pan_doc: empDocumentdata?.pan_card_front_doc || null,
            pan_bk_doc: empDocumentdata?.pan_card_back_doc || null,
            qualification: empDocumentdata?.qualification_doc || null,
            offerletter: empDocumentdata?.offer_letter_doc || null,
            // work_exp_doc: empDocumentdata?.work_experience_certificate || null,
            // other_doc: empDocumentdata?.other_documents || null,
            // edu_cer_doc: empDocumentdata?.educational_certificate || null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            isSubmitting,
            isValid,
            setFieldValue,
            values,
            handleChange,
            errors,
            touched,
          }) => (
            <Form>
              {spinning ? (
                <div className=" flex justify-center h-[22.5vw] items-center">
                  <Spin size="large" />
                </div>
              ) : (
                <>
                  <div className="gap-y-[1.5vw] flex-col flex">
                    <div className="overflow-y-scroll gap-y-[1.5vw] flex-col flex h-[18vw] pb-[1vw]">
                      <div className="grid grid-cols-2 w-full gap-x-[2vw] pr-[.5vw]">
                        <div className="col-span-1 relative">
                          <label className="text-[#1F4B7F] text-[1.1vw] ">
                            Aadhaar Card Number
                            <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                              *
                            </span>
                          </label>
                          <Field
                            type="text"
                            autoComplete="off"
                            name="aadhar_number"
                            placeholder="Enter Aadhaar Number"
                            innerRef={inputRef1}
                            maxLength={12}
                            onKeyDown={handleKeyDown}
                            value={values.aadhar_number}
                            disabled={updatedata && empDocumentdata?.aadhar_card_front_doc ? (enable ? false : true) : false}
                            className={` ${updatedata && empDocumentdata?.aadhar_card_front_doc
                              ? enable == false
                                ? " cursor-not-allowed"
                                : ""
                              : ""
                              } border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder:font-sans`}
                          />
                          <ErrorMessage
                            name="aadhar_number"
                            component="div"
                            // style={{ color: "red" }}
                            className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.2vw]"
                          />
                        </div>
                        <div className="col-span-1 relative">
                          <label className="text-[#1F4B7F] text-[1.1vw] ">
                            PAN Card Number
                            <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                              *
                            </span>
                          </label>
                          <Field
                            type="text"
                            name="pan_number"
                            autoComplete="off"
                            placeholder="Enter PAN Number"
                            innerRef={inputRef2}
                            onChange={(e) => setFieldValue("pan_number", e.target.value?.toUpperCase())}
                            value={values.pan_number}
                            disabled={updatedata && empDocumentdata?.aadhar_card_front_doc ? (enable ? false : true) : false}
                            className={` ${updatedata && empDocumentdata?.aadhar_card_front_doc
                              ? enable == false
                                ? " cursor-not-allowed"
                                : ""
                              : ""
                              } border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder:font-sans`}
                          />
                          <ErrorMessage
                            name="pan_number"
                            component="div"
                            // style={{ color: "red" }}
                            className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.2vw]"
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-y-[1.5vw] w-full pr-[.5vw] gap-x-[1.5vw]">
                        <div className="col-span-1 relative">
                          <label className="text-[#1F4B7F] text-[1.1vw]">
                            Aadhaar  Front Doc
                            <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                              *
                            </span>
                            <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                          </label>
                          <div>
                            <input
                              id="aadhar_doc"
                              name="aadhar_doc"
                              type="file"
                              accept=".jpg, .jpeg, .png .pdf"
                              style={{ display: "none" }}
                              onChange={(event) => {
                                const files = Array.from(event.target.files);
                                console.log(files, "filesfiles");
                                setFieldValue(
                                  "aadhar_doc",
                                  event.currentTarget.files[0]
                                );
                                // handlePreview(files[0]);
                                handleFileChange(event, "aadharfr");
                              }}
                              disabled={
                                updatedata && empDocumentdata?.aadhar_card_front_doc ? (enable ? false : true) : false
                              }
                            />
                            <div className="relative">
                              <button
                                type="button"
                                className={` ${updatedata && empDocumentdata?.aadhar_card_front_doc
                                  ? enable == false
                                    ? " cursor-not-allowed"
                                    : ""
                                  : ""
                                  } border-r-[0.3vw]  flex items-center justify-between px-[0.5vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  document.getElementById("aadhar_doc").click();
                                }}
                              >
                                <span className="font-sans text-[#9ba6bbe3] text-[0.9vw]">
                                 { 
    values?.aadhar_doc?.type === "application/pdf"||empDocumentdata?.aadhar_front_file?.type==="application/pdf"
      ? values?.aadhar_doc?.name || empDocumentdata?.aadhar_front_file?.filename
      : "Upload Aadhaar Front Doc"}
                                </span>
                                {/* <FaCloudUploadAlt
                          color="#1F487C"
                          size={"2vw"}
                          className="absolute right-[1vw]"
                        /> */}
                              </button>
                              {inputPreview?.aadharfr ? (
                                inputPreview?.aadharfr?.startsWith("blob") ? (
                                  <img
                                    src={inputPreview.aadharfr}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw] right-[.3vw]"
                                    alt="Aadhar Front"
                                    onClick={openModal}
                                  />
                                ) : (
                                  empDocumentdata?.aadhar_front_file?.type==="application/pdf"?
                                                                  <FaCloudUploadAlt
                                                                  color="#1F487C"
                                                                  size="1.8vw"
                                                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                                                />
                                                                :
                                  <img
                                    src={`${apiImgUrl}${inputPreview.aadharfr}`}
                                    className="h-[2.5vw] w-[2.5vw] absolute  top-[.2vw] cursor-zoom-in right-[.3vw]"
                                    alt="Aadhar Front"
                                    onClick={openModal}
                                  />
                                )
                              ) : (
                                <FaCloudUploadAlt
                                  color="#1F487C"
                                  size="2vw"
                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                />
                              )}
                            </div>
                            {/* {values.aadhar_doc && (
                        <div
                          onClick={() => {
                            setPreviewImage(empDocumentdata?.aadhar_card_front_doc);
                            setPreviewOpen(true);
                          }}
                          className="cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[0.8vw]"
                        >
                          {values.aadhar_doc.name
                            ? values.aadhar_doc.name
                            : values.aadhar_doc}
                        </div>
                      )} */}
                            <ErrorMessage
                              name="aadhar_doc"
                              component="div"
                              // style={{ color: "red" }}
                              className="text-[0.8vw] text-red-500 absolute bottom-[-1.2vw] left-[.2vw]"
                            />
                          </div>
                        </div>
                        <div className="col-span-1 relative">
                          <label className="text-[#1F4B7F] text-[1.1vw]">
                            Aadhaar Back Doc
                            <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                              *
                            </span>
                            <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                          </label>
                          <div>
                            <input
                              id="aadhar_bk_doc"
                              name="aadhar_bk_doc"
                              type="file"
                              accept=".jpg, .jpeg, .png .pdf"
                              style={{ display: "none" }}
                              onChange={(event) => {
                                const files = Array.from(event.target.files);
                                console.log(files, "filesfiles");
                                setFieldValue(
                                  "aadhar_bk_doc",
                                  event.currentTarget.files[0]
                                );
                                // handlePreview(files[0]);
                                handleFileChange(event, "aadharbk");
                              }}
                              disabled={
                                updatedata && empDocumentdata?.aadhar_card_front_doc ? (enable ? false : true) : false
                              }
                            />
                            <div className="relative">
                              <button
                                type="button"
                                className={` ${updatedata && empDocumentdata?.aadhar_card_front_doc
                                  ? enable == false
                                    ? " cursor-not-allowed"
                                    : ""
                                  : ""
                                  } border-r-[0.3vw]  flex items-center justify-between px-[0.5vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  document.getElementById("aadhar_bk_doc").click();
                                }}
                              >
                                <span className="font-sans text-[#9ba6bbe3] text-[0.9vw]">
                                   { 
    values?.aadhar_bk_doc?.type === "application/pdf"||empDocumentdata?.aadhar_back_file?.type==="application/pdf"
      ? values?.aadhar_bk_doc?.name || empDocumentdata?.aadhar_back_file?.filename
      : "Upload Aadhaar Back Doc"}
                                </span>
                              </button>
                              {inputPreview?.aadharbk ? (
                                inputPreview?.aadharbk?.startsWith("blob") ? (
                                  <img
                                    src={inputPreview.aadharbk}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw] right-[.3vw]"
                                    alt="Aadhar Front"
                                    onClick={openModal}
                                  />
                                ) : (
                                  <img
                                    src={`${apiImgUrl}${inputPreview.aadharbk}`}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw] right-[.3vw]"
                                    alt="Aadhar Front"
                                    onClick={openModal}
                                  />
                                )
                              ) : (
                                <FaCloudUploadAlt
                                  color="#1F487C"
                                  size="2vw"
                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                />
                              )}
                            </div>
                            {/* {values.aadhar_bk_doc && (
                        <div
                          onClick={() => {
                            setPreviewImage(empDocumentdata?.aadhar_card_back_doc);
                            setPreviewOpen(true);
                          }}
                          className="cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[0.8vw]"
                        >
                          {values.aadhar_bk_doc.name
                            ? values.aadhar_bk_doc.name
                            : values.aadhar_bk_doc}
                        </div>
                      )} */}
                            <ErrorMessage
                              name="aadhar_bk_doc"
                              component="div"
                              // style={{ color: "red" }}
                              className="text-[0.8vw] text-red-500 absolute bottom-[-1.2vw] left-[.2vw]"
                            />
                          </div>
                        </div>
                        <div className="col-span-1 relative">
                          <label className="text-[#1F4B7F] text-[1.1vw]">
                            PAN Front Doc
                            <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                              *
                            </span>
                            <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                          </label>
                          <div>
                            <input
                              id="pan_doc"
                              name="pan_doc"
                              type="file"
                              accept=".jpg, .jpeg, .png .pdf"
                              style={{ display: "none" }}
                              onChange={(event) => {
                                const files = Array.from(event.target.files);
                                // setFieldValue("aadhar_back", files);
                                setFieldValue(
                                  "pan_doc",
                                  event.currentTarget.files[0]
                                );
                                // handlePreview(files[0]);
                                handleFileChange(event, "panfr");
                              }}
                              disabled={
                                updatedata && empDocumentdata?.aadhar_card_front_doc ? (enable ? false : true) : false
                              }
                            />
                            <div className="relative">
                              <button
                                type="button"
                                className={` ${updatedata && empDocumentdata?.aadhar_card_front_doc
                                  ? enable == false
                                    ? " cursor-not-allowed"
                                    : ""
                                  : ""
                                  } border-r-[0.3vw] flex items-center justify-between px-[0.5vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  document.getElementById("pan_doc").click();
                                }}
                              >
                                <span className="font-sans text-[#9ba6bbe3] text-[0.9vw]">
                                    {
                                values?.pan_doc?.type === "application/pdf"||empDocumentdata?.pancard_front_file?.type==="application/pdf"
      ? values?.pan_doc?.name || empDocumentdata?.pancard_front_file?.filename
                              : " Upload PAN Front Doc" }
                                </span>
                                {/* <FaCloudUploadAlt
                          color="#1F487C"
                          size={"2vw"}
                          className="absolute right-[1vw]"
                        /> */}
                              </button>
                              {inputPreview?.panfr ? (
                                inputPreview?.panfr?.startsWith("blob") ? (
                                  <img
                                    src={inputPreview.panfr}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw] right-[.3vw]"
                                    alt="pan doc"
                                    onClick={openModal}
                                  />
                                ) : (
                                   empDocumentdata?.pancard_front_file?.type==="application/pdf"?
                                                                  <FaCloudUploadAlt
                                                                  color="#1F487C"
                                                                  size="1.8vw"
                                                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                                                />
                                                                :
                                  <img
                                    src={`${apiImgUrl}${inputPreview.panfr}`}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw] right-[.3vw]"
                                    alt="pan doc"
                                    onClick={openModal}
                                  />
                                )
                              ) : (
                                <FaCloudUploadAlt
                                  color="#1F487C"
                                  size="2vw"
                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                />
                              )}
                            </div>
                            {/* {values.pan_doc && (
                        <div
                          onClick={() => {
                            setPreviewImage(empDocumentdata?.pan_card_front_doc);
                            setPreviewOpen(true);
                          }}
                          className="cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[0.8vw]"
                        >
                          {values.pan_doc.name
                            ? values.pan_doc.name
                            : values.pan_doc}
                        </div>
                      )} */}
                            <ErrorMessage
                              name="pan_doc"
                              component="div"
                              // style={{ color: "red" }}
                              className="text-[0.8vw] text-red-500 absolute bottom-[-1.2vw] left-[.2vw]"
                            />
                          </div>
                        </div>
                        <div className="col-span-1 relative">
                          <label className="text-[#1F4B7F] text-[1.1vw]">
                            PAN Back Doc
                            <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                              *
                            </span>
                            <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                          </label>
                          <div>
                            <input
                              id="pan_bk_doc"
                              name="pan_doc"
                              type="file"
                              accept=".jpg, .jpeg, .png .pdf"
                              style={{ display: "none" }}
                              onChange={(event) => {
                                const files = Array.from(event.target.files);
                                // setFieldValue("aadhar_back", files);
                                setFieldValue(
                                  "pan_bk_doc",
                                  event.currentTarget.files[0]
                                );
                                // handlePreview(files[0]);
                                handleFileChange(event, "panbk");
                              }}
                              disabled={
                                updatedata && empDocumentdata?.aadhar_card_front_doc ? (enable ? false : true) : false
                              }
                            />
                            <div className="relative">
                              <button
                                type="button"
                                className={` ${updatedata && empDocumentdata?.aadhar_card_front_doc
                                  ? enable == false
                                    ? " cursor-not-allowed"
                                    : ""
                                  : ""
                                  } border-r-[0.3vw]  flex items-center justify-between px-[0.5vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  document.getElementById("pan_bk_doc").click();
                                }}
                              >
                                <span className="font-sans text-[#9ba6bbe3] text-[0.9vw]">
                                  {
                                values?.pan_bk_doc?.type === "application/pdf"||empDocumentdata?.pancard_back_file?.type==="application/pdf"
      ? values?.pan_bk_doc?.name || empDocumentdata?.pancard_back_file?.filename:
                                " Upload PAN Back Doc"
                               }
                                </span>
                                {/* <FaCloudUploadAlt
                          color="#1F487C"
                          size={"2vw"}
                          className="absolute right-[1vw]"
                        /> */}
                                {/* {inputPreview?.panbk  ? (
                          inputPreview?.panbk?.startsWith("blob") ? (
                            <img
                            src={inputPreview.panbk}
                            className="h-[2.5vw] w-[2.5vw] absolute right-[1vw]"
                            alt="Aadhar Front"
                          />
                          ) : (
                            <img
                            src={`http://192.168.90.47:4000${inputPreview.panbk}`}
                            className="h-[2.5vw] w-[2.5vw] absolute right-[1vw]"
                            alt="Aadhar Front"
                          />
                          )
                        ) : (
                          <FaCloudUploadAlt
                            color="#1F487C"
                            size="2vw"
                            className="absolute right-[1vw]"
                          />
                        )} */}
                              </button>
                              {inputPreview?.panbk ? (
                                inputPreview?.panbk?.startsWith("blob") ? (
                                  <img
                                    src={inputPreview.panbk}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw] right-[.3vw]"
                                    alt="pan doc"
                                    onClick={openModal}
                                  />
                                ) : (
                                   empDocumentdata?.pancard_back_file?.type==="application/pdf"?
                                                                  <FaCloudUploadAlt
                                                                  color="#1F487C"
                                                                  size="1.8vw"
                                                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                                                />
                                                                :
                                  <img
                                    src={`${apiImgUrl}${inputPreview.panbk}`}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw] right-[.3vw]"
                                    alt="pan doc"
                                    onClick={openModal}
                                  />
                                )
                              ) : (
                                <FaCloudUploadAlt
                                  color="#1F487C"
                                  size="2vw"
                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                />
                              )}
                            </div>
                            {/* {values.pan_bk_doc && (
                        <div
                          onClick={() => {
                            setPreviewImage(empDocumentdata?.pan_card_back_doc);
                            setPreviewOpen(true);
                          }}
                          className="cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[0.8vw]"
                        >
                          {values.pan_bk_doc.name
                            ? values.pan_bk_doc.name
                            : values.pan_bk_doc}
                        </div>
                      )} */}
                            <ErrorMessage
                              name="pan_bk_doc"
                              component="div"
                              // style={{ color: "red" }}
                              className="text-[0.8vw] text-red-500 absolute bottom-[-1.2vw] left-[.2vw]"
                            />
                          </div>
                        </div>
                        <div className="col-span-1 relative">
                          <label className="text-[#1F4B7F] text-[1.1vw]">
                            Qualification Doc
                            <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                              *
                            </span>
                            <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                          </label>
                          <div>
                            <input
                              id="qualification"
                              name="qualification"
                              type="file"
                              accept=".jpg, .jpeg, .png .pdf"
                              style={{ display: "none" }}
                              onChange={(event) => {
                                const files = Array.from(event.target.files);
                                console.log(files, "filesfiles");
                                // setFieldValue("pan_front", files);
                                setFieldValue(
                                  "qualification",
                                  event.currentTarget.files[0]
                                );
                                // handlePreview(files[0]);
                                handleFileChange(event, "qualification");
                              }}
                              disabled={
                                updatedata && empDocumentdata?.aadhar_card_front_doc ? (enable ? false : true) : false
                              }
                            />
                            <div className="relative">
                              <button
                                type="button"
                                className={` ${updatedata && empDocumentdata?.aadhar_card_front_doc
                                  ? enable == false
                                    ? " cursor-not-allowed"
                                    : ""
                                  : ""
                                  } border-r-[0.3vw]  flex items-center justify-between px-[0.5vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  document.getElementById("qualification").click();
                                }}
                              >
                                <span className="font-sans text-[#9ba6bbe3] text-[0.9vw]">
                                 {
                                values?.qualification?.type === "application/pdf"||empDocumentdata?.qualification?.type==="application/pdf"
      ? values?.qualification?.name || empDocumentdata?.qualification?.filename:
                                " Upload Qualification Doc"
                               }
                                </span>
                                {/* <FaCloudUploadAlt
                          color="#1F487C"
                          size={"2vw"}
                          className="absolute right-[1vw]"
                        /> */}
                              </button>
                              {inputPreview?.qualification ? (
                                inputPreview?.qualification?.startsWith("blob") ? (
                                  <img
                                    src={inputPreview.qualification}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.1vw] right-[.3vw]"
                                    alt="Aadhar Front"
                                    onClick={openModal}
                                  />
                                ) : (
                                   empDocumentdata?.qualification?.type==="application/pdf"?
                                                                  <FaCloudUploadAlt
                                                                  color="#1F487C"
                                                                  size="1.8vw"
                                                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                                                />
                                                                :
                                  <img
                                    src={`${apiImgUrl}${inputPreview.qualification}`}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.1vw] right-[.3vw]"
                                    alt="Aadhar Front"
                                    onClick={openModal}
                                  />
                                )
                              ) : (
                                <FaCloudUploadAlt
                                  color="#1F487C"
                                  size="2vw"
                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                />
                              )}
                            </div>
                            {/* {values.qualification && (
                        <div
                          onClick={() => {
                            setPreviewImage(
                              empDocumentdata?.qualification_doc
                            );
                            setPreviewOpen(true);
                          }}
                          className="cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[0.8vw]"
                        >
                          {values.qualification.name
                            ? values.qualification.name
                            : values.qualification}
                        </div>
                      )} */}
                            <ErrorMessage
                              name="qualification"
                              component="div"
                              // style={{ color: "red" }}
                              className="text-[0.8vw] text-red-500 absolute bottom-[-1.2vw] left-[.2vw]"
                            />
                          </div>
                        </div>
                        <div className="col-span-1 relative">
                          <label className="text-[#1F4B7F] text-[1.1vw]">
                            Offer Letter Doc
                            <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                              *
                            </span>
                            <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                          </label>
                          <div>
                            <input
                              id="offerletter"
                              name="offerletter"
                              type="file"
                              accept=".jpg, .jpeg, .png .pdf"
                              style={{ display: "none" }}
                              onChange={(event) => {
                                const files = Array.from(event.target.files);
                                console.log(files, "filesfiles");
                                // setFieldValue("pan_back", files);
                                setFieldValue(
                                  "offerletter",
                                  event.currentTarget.files[0]
                                );
                                // handlePreview(files[0]);
                                handleFileChange(event, "offerletter");
                              }}
                              disabled={
                                updatedata && empDocumentdata?.aadhar_card_front_doc ? (enable ? false : true) : false
                              }
                            />
                            <div className="relative">
                              <button
                                type="button"
                                className={` ${updatedata && empDocumentdata?.aadhar_card_front_doc
                                  ? enable == false
                                    ? " cursor-not-allowed"
                                    : ""
                                  : ""
                                  } border-r-[0.3vw]  flex items-center justify-between px-[0.5vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  document.getElementById("offerletter").click();
                                }}
                              >
                                <span className="font-sans text-[#9ba6bbe3] text-[0.9vw]">
                                  {
                                values?.offerletter?.type === "application/pdf"||empDocumentdata?.qualification?.type==="application/pdf"
      ? values?.offerletter?.name || empDocumentdata?.qualification?.filename:
                                " Upload Offer Letter Doc"
                               }
                                </span>
                                {/* <FaCloudUploadAlt
                          color="#1F487C"
                          size={"2vw"}
                          className="absolute right-[1vw]"
                        /> */}
                              </button>
                              {inputPreview?.offerletter ? (
                                inputPreview?.offerletter?.startsWith("blob") ? (
                                  <img
                                    src={inputPreview.offerletter}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.1vw] right-[.3vw]"
                                    alt="Aadhar Front"
                                    onClick={openModal}
                                  />
                                ) : (
                                     empDocumentdata?.offerletter?.type==="application/pdf"?
                                                                  <FaCloudUploadAlt
                                                                  color="#1F487C"
                                                                  size="1.8vw"
                                                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                                                />
                                                                :
                                  <img
                                    src={`${apiImgUrl}${inputPreview.offerletter}`}
                                    className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.1vw] right-[.3vw]"
                                    alt="Aadhar Front"
                                    onClick={openModal}
                                  />
                                )
                              ) : (
                                <FaCloudUploadAlt
                                  color="#1F487C"
                                  size="2vw"
                                  className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                                />
                              )}
                            </div>
                            {/* {values.offerletter && (
                        <div
                          onClick={() => {
                            setPreviewImage(empDocumentdata?.offer_letter_doc);
                            setPreviewOpen(true);
                          }}
                          className="cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[0.8vw]"
                        >
                          {values.offerletter.name
                            ? values.offerletter.name
                            : values.offerletter}
                        </div>
                      )} */}
                            <ErrorMessage
                              name="offerletter"
                              component="div"
                              // style={{ color: "red" }}
                              className="text-[0.8vw] text-red-500 absolute bottom-[-1.2vw] left-[.2vw]"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center  w-full justify-between  pt-[1.5vw] pb-[1vw]">
                    <div>
                      <h1 className="text-[#1F4B7F] text-[0.7vw] font-semibold">
                        *You must fill in all fields to be able to continue
                      </h1>
                    </div>
                    <div className="flex items-center gap-x-[1vw]">
                      <button
                        className="border-[#1F487C] w-[5vw] font-semibold text-[1vw] h-[2vw] rounded-full border-r-[0.2vw]  border-l-[0.1vw] border-t-[0.1vw] border-b-[0.2vw]"
                        onClick={() => {
                          setCurrentpage(3);
                          setDocumentBack(true);
                        }}
                      >
                        Back
                      </button>
                      <button
                        className="bg-[#1F487C] font-semibold rounded-full px-[.5vw] min-w-[7vw] h-[2vw] text-[1vw] text-white"
                        type="submit"
                      // onClick={() => setCurrentpage(4)}
                      >
                        {updatedata && empDocumentdata?.aadhar_card_front_doc != null ? enable
                          ? "Update & Submit"
                          : "Submit"
                          : "Submit"}
                      </button>
                    </div>
                  </div>
                </>)}
            </Form>
          )}
        </Formik>
      </div>

      {/* <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{ width: "100%" }}
          src={`http://192.168.90.47:4000${previewImage}`}
        />
      </Modal> */}
      <Modal
        visible={isModalOpen}
        onCancel={closeModal}
        footer={null}
        centered
        // width="35vw"
        bodyStyle={{ padding: 0 }}
        destroyOnClose={true} // Ensures modal is destroyed on close
      >
        {/* Display the image in the modal */}
        {modalImage && (
          <img
            src={modalImage}
            alt="Documents Preview"
            style={{ width: "100%" }}
            className=""
          />
        )}
      </Modal>
    </div>
  );
}
